import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { DbShareTenderFolder, TenderSubFolderCoreVM } from '~src/types/db';
import { loadTendersFoldersShare } from '~src/services/api/shares';

interface UseSharedTenderFoldersParams {
  id?: string;
  key?: string;
}
export const useSharedTenderFolders = (
  { id, key }: UseSharedTenderFoldersParams = {},
  queryConfig: QueryConfig<DbShareTenderFolder[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const { enabled, ...options } = queryConfig;
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderFoldersQuery = useQuery<DbShareTenderFolder[], AxiosError>(
    [
      {
        id,
        key,
      },
      'sharedTenderFolders',
    ],
    loadTendersFoldersShare,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite,
      ...options,
    }
  );

  return tenderFoldersQuery;
};
